var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nav"}},[_c('v-bottom-navigation',{attrs:{"color":"primary","absolute":"","grow":""}},_vm._l((_vm.menus),function(menu){return _c('v-btn',{key:menu.title,attrs:{"to":menu.route}},[_c('span',[_vm._v(_vm._s(menu.title))]),_c('v-icon',[_vm._v(_vm._s(menu.icon))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }